import React from 'react'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'
import { Container } from '@mui/material'

const useStyles = makeStyles()((theme: Theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  header: {
    paddingBottom: theme.spacing(0.5),
  },
}))

export type CenteredContainerProps = {
  header?: React.ReactNode
  children?: React.ReactNode
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

const CenteredContainer: React.FC<CenteredContainerProps> = ({
  header,
  children,
  maxWidth = 'md',
}: CenteredContainerProps) => {
  const { classes } = useStyles()
  return (
    <Container maxWidth={maxWidth} className={classes.content}>
      {header && <div className={classes.header}>{header}</div>}
      {children}
    </Container>
  )
}

export default CenteredContainer
